import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './anlaufstelleverwaltung.module.scss';
import {anlaufstelleverwaltungRun} from './anlaufstelleverwaltung.route';
import {AnlaufstelleverwaltungViewComponentConfig} from './component/anlaufstelleverwaltungView/anlaufstelleverwaltungView';
import {AnlaufstelleViewComponentConfig} from './component/anlaufstelleView/anlaufstelleView';
import {AnlaufstelleRegistrierungViewComponentConfig} from './component/anlaufstelleRegistrierungView/anlaufstelleRegistrierungView';

export const SerfWebAnlaufstelleverwaltung = angular.module('serfWeb.anlaufstelleverwaltung', [SerfWebCore.name])
    .component('dvAnlaufstelleverwaltungView', new AnlaufstelleverwaltungViewComponentConfig())
    .component('dvAnlaufstelleView', new AnlaufstelleViewComponentConfig())
    .component('dvAnlaufstelleRegistrierungView', new AnlaufstelleRegistrierungViewComponentConfig())
    .run(anlaufstelleverwaltungRun);

export default SerfWebAnlaufstelleverwaltung;



// WEBPACK FOOTER //
// ./src/app/anlaufstelleverwaltung/anlaufstelleverwaltung.module.ts